import { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useTheme } from '../../themes/theme.provider';
import { useUser } from '../../hook/user.hook';
import FullScreenComponent from './component/full-screen.component';
import InstructionComponent from './component/instruction.component';
import OverviewComponent from './component/overview.component';
import SideMenuComponent from './component/side-menu.component';
import TimerComponent from './component/timer.component';
import SaveStatusComponent from './component/save-status.component';
import JeeQuestionHolderMComponent from './component/jee/jee-question-holder-m.component';
import JeeActionMComponent from './component/jee/jee-action-m.component';
import JeeSummaryMComponent from './component/jee/jee-summary-m.component';
import JeeNavigationMComponent from './component/jee/jee-navigation-m.component';

const TestJeeMPage = () => {
  const { theme } = useTheme();
  const { candidateConfig } = useUser();
  const [isOpenBottomWrapper, setIsOpenBottomWrapper] = useState(false);

  const handleBottomWrapper = () => {
    setIsOpenBottomWrapper(!isOpenBottomWrapper);
  };

  return (
    <>
      <section
        className="pt-3 d-flex flex-column"
        style={{ height: '100dvh', overflow: 'hidden' }}
      >
        {/* Header */}
        <Row className="m-0 mb-1 flex-shrink-0">
          <Col
            lg={12}
            className="px-1 border-bottom border-gainsboro pb-2 text-white d-flex align-items-center"
          >
            <SideMenuComponent />

            {candidateConfig?.candidate && (
              <span className="px-1">
                {candidateConfig.candidate.enrollmentId ?? 'Hi, Student'}
              </span>
            )}
            <div className="border-start border-gainsboro">
              <img src="/images/logo-tr.svg" width="72" height="24" alt="" />
            </div>

            <div className="ms-auto d-flex align-items-center">
              <FullScreenComponent />

              <OverviewComponent />
            </div>
          </Col>
        </Row>

        {/* Instruction & Timer */}
        <div className="py-2 px-2 d-flex align-items-center justify-content-between flex-shrink-0">
          <InstructionComponent />
          <TimerComponent />
        </div>

        {/* Question Holder - Scrollable */}
        <div
          className="bg-secondary rounded-16 px-2 m-1 flex-grow-1"
          style={{ overflowY: 'auto', minHeight: 0 }}
        >
          <JeeQuestionHolderMComponent />
        </div>

        {/* JEE Bottom Action Bar - Fixed at bottom */}
        <div
          className="bg-secondary flex-shrink-0"
          style={{
            position: 'sticky',
            bottom: 0,
            maxHeight: isOpenBottomWrapper ? '70vh' : 'auto',
            transition: 'max-height 0.3s ease-in-out',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Toggle Button */}
          <div className="text-center py-1 flex-shrink-0">
            <Button
              variant="link"
              className="text-white p-0 border-0"
              onClick={handleBottomWrapper}
            >
              <img
                src={`/images/${
                  isOpenBottomWrapper ? 'down-arrow.svg' : 'up-arrow.svg'
                }`}
                alt=""
              />
            </Button>
          </div>

          {/* Action Buttons - Always visible */}
          <div className="px-2 pb-2 flex-shrink-0">
            <JeeActionMComponent />
          </div>

          {/* Expanded Content - Scrollable inside */}
          {isOpenBottomWrapper && (
            <div
              style={{
                background: theme.primary,
                overflowY: 'auto',
                flex: 1,
                minHeight: 0,
              }}
              className="px-2 py-3"
            >
              {/* Summary - Horizontal layout for mobile */}
              <div className="mb-3">
                <JeeSummaryMComponent />
              </div>

              {/* Question Navigation */}
              <JeeNavigationMComponent />

              {/* Save Status */}
              <div className="text-center mt-3 pt-2">
                <SaveStatusComponent fontSize="ft-12" />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default TestJeeMPage;
